import { Box, Button, Flex, Heading, Text, VStack, Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLastLiveVideoRequest, saveLiveVideoSeenRequest } from "../../../modules/students-modules/live-videos/Actions";
import { getEnrolledCoursesRequest } from "../../../modules/students-modules/courses/Actions";

const StudentLiveVideos = () => {
  const dispatch = useDispatch();
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const lastLiveVideo = useSelector((state) => state.studentLiveVideos.lastLiveVideo);
  const isJoinEnabled = useSelector((state) => state.studentLiveVideos.enabled);
  const { courses } = useSelector((state) => state.studentCourses);

  useEffect(() => {
    dispatch(getEnrolledCoursesRequest());
  }, [dispatch]);

  useEffect(() => {
    if (courses && courses.length > 0 && !selectedCourseId) {
      setSelectedCourseId(courses[0].id);
    }
  }, [courses, selectedCourseId]);

  useEffect(() => {
    if (selectedCourseId) {
      dispatch(getLastLiveVideoRequest(selectedCourseId));
    }
  }, [selectedCourseId, dispatch]);

  const handleSeen = () => {
    if (lastLiveVideo) {
      const data = {
        zoom_id: lastLiveVideo?.id
      };
      
      const action = () => {
        dispatch(getLastLiveVideoRequest(selectedCourseId));
      };
      
      dispatch(saveLiveVideoSeenRequest(data, action));
    }
  };

  const requiredExam = lastLiveVideo?.exams?.[0];

  const handleSolveExam = () => {
    if (!requiredExam?.id) return;
    const path = window.location.pathname.includes("student")
      ? `/student/exam-guide/${requiredExam.id}?name=${requiredExam.name}`
      : `/exam-guide/${requiredExam.id}?name=${requiredExam.name}`;
    window.location.href = path;
  };

  if (!courses || courses.length === 0) {
    return (
      <Box p={6}>
        <Text>لا توجد دورات مسجلة</Text>
      </Box>
    );
  }

  return (
    <Box p={6}>
      <VStack spacing={6} align="stretch">
        <Heading size="lg" textAlign="center" color="main_1">
          الفيديوهات المباشرة
        </Heading>
        
        <Tabs 
          variant="enclosed" 
          onChange={(index) => {
            const courseId = courses[index].id;
            setSelectedCourseId(courseId);
          }}
          defaultIndex={0}
        >
          <TabList>
            {courses.map((course, index) => (
              <Tab key={course.id}>{course.name}</Tab>
            ))}
          </TabList>
          
          <TabPanels>
            {courses.map((course) => (
              <TabPanel key={course.id}>
                {!lastLiveVideo ? (
                  <Box p={6} textAlign="center">
                    <Text fontSize="lg" color="gray.500">
                      لا توجد فيديوهات مباشرة متاحة لهذه الدورة
                    </Text>
                  </Box>
                ) : (
                  <Box 
                    borderWidth="1px" 
                    borderRadius="lg" 
                    p={6} 
                    bg="white"
                    boxShadow="md"
                  >
                    <VStack spacing={4} align="stretch">
                      <Box>
                        <Heading size="md" mb={2}>
                          {lastLiveVideo?.title}
                        </Heading>
                      </Box>
                      
                      <Box>
                        <Text fontWeight="bold" mb={1}>
                          الرابط:
                        </Text>
                        <Button
                          colorScheme="blue"
                          isDisabled={!isJoinEnabled}
                          onClick={() => {
                            if (!isJoinEnabled) return;
                            handleSeen();
                            window.open(lastLiveVideo?.zoom_link, '_blank');
                          }}
                        >
                          الذهاب إلى رابط البث المباشر
                        </Button>
                        {!isJoinEnabled && requiredExam && (
                          <Box mt={3}>
                            <Text color="red.500" mb={2}>
                              يجب حل الاختبار أولاً: {requiredExam?.name}
                            </Text>
                            <Button
                              colorScheme="orange"
                              variant="outline"
                              onClick={handleSolveExam}
                            >
                              حل الاختبار
                            </Button>
                          </Box>
                        )}
                        {!isJoinEnabled && !requiredExam && (
                          <Text color="red.500" mt={3}>
                            يجب حل اختبار الفيديو المباشر أولاً قبل الانضمام
                          </Text>
                        )}
                      </Box>
                    </VStack>
                  </Box>
                )}
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </VStack>
    </Box>
  );
};

export default StudentLiveVideos; 